import { Button, Card, Checkbox, Col, Form, Row, Spin } from 'antd';
import { useContext, useEffect } from 'react';
import gql from 'graphql-tag';
import CTX from '../../lib/AssignmentsContext';
import { useQuery } from '../../lib/hooks';
import { PROFICIENCY_CUTS } from '../../helpers/reportConsts';
const IMPROFICENT_CUTS = PROFICIENCY_CUTS.slice(1, -1);
const StudentsPicker = ({
  onCancel
}) => {
  const {
    data: assignmentData,
    filters: {
      skillFilter
    }
  } = useContext(CTX);
  const {
    data,
    loading,
    error
  } = useQuery(gql`
			query METRIC_CLASS_SKILL_SCORES(
				$classID: ID!
				$domain: String!
				$subDomain: String
				$skill: String
				$subSkill: String
			) {
				classById(id: $classID) {
					students {
						id
						skillScore(classID: $classID, domain: $domain, subDomain: $subDomain, skill: $skill, subSkill: $subSkill) {
							recentScore
						}
					}
				}
			}
		`, {
    variables: {
      ...skillFilter,
      classID: assignmentData.klass.id
    },
    skip: !skillFilter
  });
  const skillData = Object.fromEntries(data?.classById.students.map(s => [s.id, s.skillScore.recentScore]) || []);
  const sortedStudents = [...assignmentData.klass.students].sort((a, b) => a.name > b.name ? 1 : -1);
  const cols = 3;
  const rows = Math.ceil(assignmentData.klass.students.length / cols);
  const [form] = Form.useForm();
  useEffect(() => {
    form.validateFields();
  });
  const defaultAssignedTo = skillData && assignmentData.studentIDs.length === 0 ? Object.entries(skillData).filter(([id, score]) => IMPROFICENT_CUTS.some(c => c.includes(score))).map(([id, score]) => id) : assignmentData.studentIDs;
  if (loading) {
    return <Spin />;
  }
  return <Form form={form} initialValues={{
    assignedTo: defaultAssignedTo
  }} onFinish={vals => {
    assignmentData.studentIDs = vals.assignedTo;
  }} data-sentry-element="Form" data-sentry-component="StudentsPicker" data-sentry-source-file="StudentsPicker.jsx">
			<Card data-sentry-element="Card" data-sentry-source-file="StudentsPicker.jsx">
				<h3 className="step-title">Choose Students</h3>
				<Form.Item noStyle name="assignedTo" rules={[{
        message: 'required',
        validator: async (_, v) => {
          if (Array.isArray(v) && v.length > 0) {
            return;
          }
          throw new Error('is empty');
        }
      }]} data-sentry-element="unknown" data-sentry-source-file="StudentsPicker.jsx">
					<Checkbox.Group style={{
          width: '100%',
          display: 'inline-block'
        }} data-sentry-element="unknown" data-sentry-source-file="StudentsPicker.jsx">
					{skillFilter ? <Row gutter={[8, 8]}>
							{PROFICIENCY_CUTS.map(cut => <Col key={cut.name} span={24 / PROFICIENCY_CUTS.length}>
										<h3 style={{
                color: cut.color
              }}>{cut.name}</h3>
										<ul style={{
                padding: 0,
                listStyle: 'inside none'
              }}>
										{sortedStudents.filter(e => cut.includes(skillData[e.id])).map(e => <li key={e.id}>
													<Checkbox value={e.id}>{e.name}</Checkbox>
												</li>)}
										</ul>
									</Col>)}
							</Row> : Array(rows).fill(null).map((_, row) => <Row key={`row-${row}`} gutter={[8, 8]}>
								{sortedStudents.slice(cols * row, cols * row + cols).map(e => <Col key={`subEntity-${e.id}`} span={Math.floor(24 / cols)}>
											<Checkbox value={e.id}>{e.name}</Checkbox>
										</Col>)}
								</Row>)}
					</Checkbox.Group>
				</Form.Item>
				<br />
				<div className="pop-up-display">
					<Button type="primary" onClick={() => {
          form.setFieldsValue({
            assignedTo: sortedStudents.map(e => e.id)
          });
          form.validateFields(['assignedTo']);
        }} data-sentry-element="Button" data-sentry-source-file="StudentsPicker.jsx">
						Select All
					</Button>
					{' '}
					<Button onClick={() => {
          form.setFieldsValue({
            assignedTo: []
          });
          form.validateFields(['assignedTo']);
        }} data-sentry-element="Button" data-sentry-source-file="StudentsPicker.jsx">
						Deselect All
					</Button>
				</div>
			</Card>
			<Row type="flex" justify="space-between" data-sentry-element="Row" data-sentry-source-file="StudentsPicker.jsx">
				{onCancel && <Col>
							<Button type="default" onClick={onCancel}>
								Back
							</Button>
						</Col>}
				<Col data-sentry-element="Col" data-sentry-source-file="StudentsPicker.jsx">
					<Form.Item shouldUpdate noStyle data-sentry-element="unknown" data-sentry-source-file="StudentsPicker.jsx">
					{() => <Button type="primary" htmlType="submit" disabled={form.getFieldsError().some(({
            errors
          }) => errors.length > 0)}>
								Next
							</Button>}
					</Form.Item>
				</Col>
			</Row>
		</Form>;
};
export default StudentsPicker;